// Feature flags derived from config. Read once at boot; treat as immutable.
// When/if a remote flag provider (LaunchDarkly, GrowthBook) lands, wire it
// here so callers continue to read from `flags.*` without knowing the source.

import { config } from './config'

export const flags = {
  sentryEnabled: config.sentry.dsn.length > 0,
  webVitalsEnabled: config.webVitals.enabled,
} as const
